$shm_service_task_menu $shm_remove_menu
	remove_confirm_title \Удалить задачу?
